import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { FormattedMessage } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import Main from 'components/templates/Main';
import CircularProgress from 'components/shared/CircularProgress';
import moment from 'logic/moment';
import NewsContent from './news-content';

const NewsDetail = ({ news }) => {
  return (
    <>
      <Box p={2} my={2} boxShadow={3}>
        <Typography variant="h5">{news.title}</Typography>
        <Typography variant="caption">{moment(news.published_from).format('LLL')}</Typography>
        <Box my={3}>
          <NewsContent text={news.body} />
        </Box>
      </Box>
    </>
  );
};

NewsDetail.propTypes = {
  news: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    summary: PropTypes.string,
    published_at: PropTypes.string,
    body: PropTypes.string,
    published_from: PropTypes.string,
  }),
};

const NewsComponent = ({ loading, error, news }) => {
  return (
    <Main
      title={
        <div>
          <FormattedMessage id="news.title" defaultMessage="News" />
        </div>
      }
    >
      <Box boxShadow={3} p={2}>
        {loading && <CircularProgress />}

        {error && (
          <Alert severity="error" elevation={1}>
            <FormattedMessage
              id="news.error"
              defaultMessage="There was an error fetching the news"
            />
          </Alert>
        )}
        {!!news && <NewsDetail news={news} />}
      </Box>
    </Main>
  );
};

NewsComponent.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({}), PropTypes.string]),
  news: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    summary: PropTypes.string,
    published_from: PropTypes.string,
    published_to: PropTypes.string,
    body: PropTypes.string,
  }),
};

export default NewsComponent;
